export const HINTS = {
	ParentCompanyCountry:
		'If you want to base the company in a different region, change or remove the parent company',
	JobEmailDescription:
		'You can use this if you are advertising directly with a job board. \nJust place the email in the forwarding section on the board and applications will be directed here',
} as const;
